import { Injectable } from '@angular/core';
import { UserDataService } from '../services/user-data.service';
import { ReportSaveService } from './report-save.service';
import { RankingService } from '../services/ranking.service';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root'
})
export class RankingReportService {

  constructor(
    public userDataService: UserDataService,
    private savingService: ReportSaveService,
    private rankingService: RankingService,
    private stateService: StateService
  ) { }

  public async generateRanking() : Promise<void> {
    try {
      const allUsersData = await this.userDataService.getAllExistingUsersData();
      const rankingArray = await this.rankingService.prepareRankingArray(allUsersData);
      const reportData = this.generateReportContent(rankingArray);
      this.save(reportData);
    } catch(e) {
      console.warn(e);
    }
  }

  private generateReportContent(rankingArray: Array<any>): Array<Array<any>> {
    const result: Array<Array<any>> = [];
    result.push(this.generateReportHeader());
    result.push(['']);
  
    const state = this.stateService.getState();
    const isPumpState = state === "state-pumps";
    const isACState = state === "state-airconditioners";
  
    let iterator = 1;
  
    rankingArray.forEach(user => {
      const points = isPumpState ? user.pumpPoints : isACState ? user.airConditionPoints : 0;
      const prizeAmount = isPumpState ? user.pumpPrizeAmount : isACState ? user.airConditionPrizeAmount : 0;
      const registeredProductsCount = isPumpState 
        ? user.pumpRegisteredProducts?.length ?? 0 
        : isACState 
          ? user.airConditionRegisteredProducts?.length ?? 0 
          : 0;
  
      if (points > 0) {
        result.push([
          user.userEmail, 
          points, 
          registeredProductsCount, 
          iterator, 
          prizeAmount, 
          user.companyName, 
          user.firstName, 
          user.lastName, 
          user.phoneNumber, 
          user.voivodeship,
          user.streetName,
          user.buildingNumber,
          user.city,
          user.postalCode
        ]);
        iterator++;
      }
    });

    // Sortujemy dane po kolumnie Województwie, teraz jest sortowane po liczbie punktów (10. indeks w wierszu)
    // const headerRows = result.slice(0, 2);
    // const dataRows = result.slice(2);

    // dataRows.sort((a, b) => {
    //   const voivA = (a[9] || '').toLowerCase();
    //   const voivB = (b[9] || '').toLowerCase();
    //   return voivA.localeCompare(voivB, 'pl');
    // });

    // return [...headerRows, ...dataRows];
  
    return result;
  }

  private generateReportHeader() : Array<string> {
    return [
      'Adres email', 
      'Liczba punktów', 
      'Liczba urządzeń', 
      'Pozycja w rankingu', 
      'Wartość nagrody', 
      'Nazwa firmy', 
      'Imię', 
      'Nazwisko', 
      'Nr telefonu', 
      'Województwo',
      'Ulica',
      'Numer',
      'Miejscowość',
      'Kod'
    ];
  }

  private save(data: Array<Array<any>>) : void {

    const state = this.stateService.getState();
    const type = state === "state-pumps" ? ' pompy' : (state === "state-airconditioners" ? ' klimatyzacja' : '');

    this.savingService.saveXlsxReport(data, `Ranking${type}.xlsx`, 'Raport')
  }
}